<template>
  <div>
    <h2>ログインする企業を選択</h2>

    <v-list class="mt-4">
      <v-list-item-group color="primary">
        <v-card class="my-2" outlined v-for="company in companies" :key="company.companyId">
          <v-list-item @click="selectCompany(company)">
            {{ company.companyName }}
          </v-list-item>
        </v-card>
      </v-list-item-group>
    </v-list>
  </div>
</template>
<script lang="ts">
import { defineComponent } from "vue";

import { meModule } from "@/store/dataModule/meModule";
import { OperationCompanyResponse } from "chaild-api/lib";
import LocalDataService from "@/service/LocalDataService";

export default defineComponent({
  computed: {
    me() {
      return meModule.me;
    },
    companies(): OperationCompanyResponse[] {
      if (this.me) {
        return this.me.companies;
      }
      return [];
    },
  },
  methods: {
    selectCompany(company: OperationCompanyResponse) {
      LocalDataService.setCompany(company);
      LocalDataService.setCompanyId(company.companyId);
      meModule.setCompany(company);
      this.$router.push({ path: "/invoice" });
      // this.$router.go(-1);
    },
  },
});
</script>
